var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.4233 24.5165C24.2116 28.5331 20.72 31.644 16.475 32.2615C14.0408 32.6274 11.5542 32.1714 9.40829 30.9656L5.7883 31.8723C4.8658 32.1015 4.02746 31.2706 4.2558 30.3473L5.1633 26.7198C3.96053 24.5758 3.50468 22.0928 3.86746 19.6615C4.58413 14.8064 8.53996 10.9264 13.4108 10.3314C15.9408 10.0189 18.3341 10.5606 20.3241 11.7114",
    stroke: "#007F7C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7431 7.68237C32.5248 8.14904 35.6031 11.1582 36.1548 14.929C36.4394 16.819 36.0852 18.7499 35.1481 20.4157L35.8531 23.2299C35.8942 23.3937 35.8921 23.5654 35.8471 23.7282C35.802 23.891 35.7156 24.0393 35.5961 24.1587C35.4767 24.2782 35.3284 24.3646 35.1656 24.4096C35.0028 24.4547 34.8311 24.4568 34.6673 24.4157L31.8523 23.7115C30.1864 24.6483 28.2555 25.0023 26.3656 24.7174C22.5948 24.1657 19.5848 21.0874 19.1198 17.3049C18.9537 16.0016 19.0883 14.6777 19.5133 13.4345C19.9382 12.1914 20.6421 11.0621 21.5711 10.1331C22.5002 9.20419 23.6296 8.50033 24.8727 8.07552C26.1159 7.65071 27.4399 7.51622 28.7431 7.68237Z",
    stroke: "#007F7C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoChat);
export default __webpack_public_path__ + "static/media/noChat.1889a87e65036e17300eced1b991b792.svg";
export { ForwardRef as ReactComponent };